import { type FC, type ReactNode } from 'react';

import {
  TonConnectUIProvider,
  type TonConnectUIProviderProps,
} from '@tonconnect/ui-react';

import { BASE_URL_MARKET, DEV_TG_BOT_LINK, PROD_TG_BOT_LINK } from '@/shared/constants';
import { isDev } from '@/shared/helpers';
import { useAppState } from '@/shared/store/app-store/app-store';

const MANIFEST_URL = 'https://pd-static.playdeck.io/static/pd-tonconnect4.json';

export const TonConnectProvider: FC<
  TonConnectUIProviderProps & { children: ReactNode }
> = ({ children, ...providerProps }) => {
  const { lang } = useAppState();

  const twaReturnUrl = isDev('replyBot')
    ? `${DEV_TG_BOT_LINK}${BASE_URL_MARKET}`
    : `${PROD_TG_BOT_LINK}${BASE_URL_MARKET}`;

  return (
    <TonConnectUIProvider
      manifestUrl={MANIFEST_URL}
      actionsConfiguration={{ twaReturnUrl }}
      language={lang}
      {...providerProps}
    >
      {children}
    </TonConnectUIProvider>
  );
};
